import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=aa48e37a&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\HK198Mall\\webim-vue-demo-demo-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa48e37a"]])

export default __exports__